import { useIntl, IntlFormatters } from "react-intl";

export type TFunction = IntlFormatters["formatMessage"];

export const useTranslations = () => {
  const intl = useIntl();

  return { t: intl.formatMessage };
};
